import { render, staticRenderFns } from "./MyAccountUserNavButton.vue?vue&type=template&id=e819435e&scoped=true&"
import script from "./MyAccountUserNavButton.vue?vue&type=script&lang=js&"
export * from "./MyAccountUserNavButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e819435e",
  null
  
)

export default component.exports